/**
 * @file   : DestinationLayoutCartConf.js
 * @author : Amarjeet Lamba (Amarjeet.Lamba@AspiraConnect.com)
 * @date   : 9/26/2018, 12:42:38 PM
 */
import PropTypes from 'prop-types'
import React from 'react'

import BoxContainer, {
  BACKGROUND_COLOR,
} from '../../../external/components/container/BoxContainer'
import AlignMultiCols from '../../../external/components/layout/AlignMultiCols'
import Cont, { ALIGN_RIGHT } from '../../../external/components/layout/Cont'
import ABaseLink from '../../../external/components/link/ABaseLink'
import TextStyler, {
  DEFAULT_HEADER,
  DEFAULT_TEXT,
  FONT_SIZE,
  FONT_WEIGHT,
  WHITE_TEXT,
} from '../../../external/components/text/TextStyler'
import {
  dangerouslyDecodeHTMLEntity,
  isEmpty,
  isUndefined,
  toTitleCase,
} from '../../../external/utilities/GeneralUtils'
import { simpleTranslate, translate } from '../../Translation'
import DestinationSummaryCard from './DestinationSummaryCard'

const DestinationLayoutCartConf = ({
  theme,
  intl,
  destinationProducts,
  locationName,
}) => {
  const getDestinationHeader = function () {
    return (
      <TextStyler
        styleObj={{
          ...DEFAULT_HEADER,
          ...WHITE_TEXT,
          fontSize: FONT_SIZE.X3,
        }}
      >
        {translate(intl, 'label_destination_header', {
          facilityName: toTitleCase(locationName),
        })}
      </TextStyler>
    )
  }

  const getDestinationFooter = function () {
    let footer = null
    let moreNearbyLink = null

    if (
      !isUndefined(destinationProducts.nearbyURL) &&
      !isEmpty(destinationProducts.nearbyURL)
    ) {
      moreNearbyLink = destinationProducts.nearbyURL
    }

    if (destinationProducts.data.length > 1) {
      footer = (
        <Cont align={ALIGN_RIGHT}>
          <TextStyler
            styleObj={{
              ...DEFAULT_TEXT,
              fontSize: FONT_SIZE.X3,
              fontWeight: FONT_WEIGHT.BOLD,
            }}
          >
            <ABaseLink
              to={dangerouslyDecodeHTMLEntity(moreNearbyLink)}
              internal={false}
              newWin
            >
              {simpleTranslate(intl, 'label_destination_more_nearby')}
            </ABaseLink>
          </TextStyler>
        </Cont>
      )
    }

    return footer
  }

  const getDestinationProductsUI = function () {
    const ui = destinationProducts.data.map((destinationProduct, i) => (
      <Cont key={i}>
        <DestinationSummaryCard
          intl={intl}
          theme={theme}
          destinationProduct={destinationProduct}
        />
      </Cont>
    ))

    return ui
  }

  if (
    isUndefined(destinationProducts) ||
    isEmpty(destinationProducts) ||
    isEmpty(destinationProducts.data)
  ) {
    return null
  }

  return (
    <BoxContainer
      header={getDestinationHeader()}
      footer={getDestinationFooter()}
      titleBackgroundColor={BACKGROUND_COLOR.HIGHLIGHT_SUCCESS}
    >
      <AlignMultiCols>{getDestinationProductsUI()}</AlignMultiCols>
    </BoxContainer>
  )
}

DestinationLayoutCartConf.propTypes = {
  theme: PropTypes.string.isRequired,
  intl: PropTypes.object.isRequired,
  destinationProducts: PropTypes.object,
  locationName: PropTypes.string.isRequired,
}

export default DestinationLayoutCartConf
